import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { XCircle, RefreshCw, ShoppingCart } from 'lucide-react';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams?.get('code') || '';
  const msg = searchParams?.get('msg') || '';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Ödeme Başarısız
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-2">
          Ödemeniz tamamlanamadı veya iptal edildi.
        </p>
        <p className="text-gray-500 text-sm mb-8">
          Kartınızda yeterli bakiye olmayabilir veya işlem iptal edilmiş olabilir. Lütfen tekrar deneyiniz.
        </p>

        {/* Status Badge */}
        <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3 mb-4">
          <p className="text-red-700 text-sm font-medium">
            ✗ Ödeme işlemi gerçekleştirilemedi
          </p>
        </div>

        {/* Error Detail */}
        {(msg || code) && (
          <p className="text-sm text-gray-500 mt-2 mb-6">
            Hata Detayı: {msg || 'Bilinmeyen Hata'}{code ? ` (Kod: ${code})` : ''}
          </p>
        )}

        {/* Actions */}
        <div className="flex flex-col gap-3 mt-4">
          <button
            onClick={() => window.location.href = '/checkout'}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-5 h-5" />
            Tekrar Dene
          </button>
          <button
            onClick={() => window.location.href = '/checkout'}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <ShoppingCart className="w-5 h-5" />
            Sepete Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
